import {
    Card,
    CardBody,
    Input,
    TableRow,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
 
} from '@windmill/react-ui';
import MinDurationTable from 'components/Minduration/MinDurationtable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import { SidebarContext } from 'context/SidebarContext';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import MinDurationServices from 'services/MinDurationServices';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import sidebar from 'routes/sidebar';
import MinDurationDrawer from 'components/drawer/MinDurationdrawer';

const MinDuration = () => {
    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;
    const { toggleDrawer } = useContext(SidebarContext);
    const { title, serviceId } = useToggleDrawer();
    const [status, setStatus] = useState('');
    const { data, loading, error } = useAsync(
        MinDurationServices.getAllMinDuration
    );

    const safeData = data;

    const isAdmin = adminInfo?.id === 1;

    const hideView = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'min duration' && perm.view === 1
    );

    const hideDelete = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'min duration' && perm.delete === 1
    );

    const hideEdit = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'min duration' && perm.edit === 1
    );

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const {
        minDurationRef,
        serviceData,
        handleSubmitminDuration,
        currentPage,
    } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);
    useEffect(() => {
        if (serviceData.length !== 0) {
            setItemsPerPage(serviceData.length);
        }
    }, [serviceData]);
    useEffect(() => {
        if (data?.status) {
            setStatus(data.status);
        } else {
            setStatus(false);
        }
    }, [data?.status]);




    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />

                    <MainDrawer>
                        <MinDurationDrawer id={serviceId} />
                    </MainDrawer>

                    <PageTitle sidebar={sidebar().sidebar} />

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <div className="flex gap-6 items-center">
                                <div className="flex-1">
                                    <Input
                                        ref={minDurationRef}
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                        type="search"
                                        name="search"
                                        placeholder="Quick Search"
                                        autoComplete="off"
                                        onChange={handleSubmitminDuration}
                                    />
                                </div>

                             
                            </div>
                        </CardBody>
                    </Card>

                    <DataWrapper loading={loading} error={error} status={status}>
                        {serviceData.length ? (
                            <TableContainer className="mb-8">
                                <div
                                    className="overflow-y-scroll"
                                    style={{ maxHeight: '65vh', scrollbarWidth: 'thin' }}
                                >
                                    <Table>
                                        <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                                            <TableRow>
                                                <TableCell>Sl.No.</TableCell>
                                                <TableCell>name</TableCell>
                                                <TableCell>Min Booking Minutes</TableCell>

                                                <TableCell>Status</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHeader>
                                        <MinDurationTable
                                            MindurationTabledata={serviceData}
                                            perpage={itemsPerPage}
                                            currentPage={currentPage}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </Table>
                                </div>
                            </TableContainer>
                        ) : (
                            <>
                                {data.status !== true ? (
                                    <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                                ) : (
                                    <NotFound title="There are no Min Duration data." />
                                )}
                            </>
                        )}
                    </DataWrapper>
                </>
            )}
        </>
    );
};

export default MinDuration;
